import { render } from "./onLinePlayers.vue?vue&type=template&id=45212b85&scoped=true"
import script from "./onLinePlayers.vue?vue&type=script&lang=ts"
export * from "./onLinePlayers.vue?vue&type=script&lang=ts"

import "./onLinePlayers.vue?vue&type=style&index=0&id=45212b85&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45212b85"

export default script